













import { Vue, Component } from "vue-property-decorator";
import DocumentTypeTaxonomyForm from "@/components/taxonomy/DocumentTypeTaxonomyForm.vue";

@Component({ components: { DocumentTypeTaxonomyForm } })
export default class DocumentTypeTaxonomyNew extends Vue {}
